/* eslint-disable quotes */
import escape from 'lodash-es/escape';

export default (product) => {
  // Use first variant
  const active_style =
    product.variants[0].barcode ||
    product.variants[0].Barcode ||
    product.variants[0].imgs.split(`products/`)[1].split(`_`)[0];
  const country = window.theme.country_iso;
  const quadpay_country = country === `US`;
  const collectionTitle = document.querySelector('[data-collection]');
  let collectionName = collectionTitle.dataset.collection;

  if (product.list_name) {
    collectionName = product.list_name;
  }

  const admind_product = {
    id: product.pid ? product.pid : product.id,
    style: active_style,
    // category: ,
    subcategory: escape(product.product_type),
    name: escape(product.title.replace(/((CLEARANCE)|(PLACEHOLDER))( - )/, '')),
    price: product.price,
    originalPrice: product.price_compare === `0.00` ? product.price : product.price_compare,
    newArrival: product.tags.includes(`New Arrival`),
    isMarkedDown: Number(product.price) < Number(product.price_compare),
    hasReviews: product.reviewsCount > 0,
    reviewCount: product.reviewsCount ? product.reviewsCount : 0,
    reviewAverage: product.review ? product.review / 20 : 0,
    showsQuadpay: quadpay_country && Number(product.price) > 14,
    almostGone: false,
    position: product.position ? product.position : 1,
  };

  const dataLayer = window.dataLayer || [];

  if (collectionTitle && window.location.href.includes('collection')) {
    dataLayer.push({
      event: `productClick`,
      ecommerce: {
        click: {
          products: [admind_product],
          actionField: {
            list: collectionName,
          },
          eventCallback: () => {
            document.location = product.product_url;
          },
          eventTimeout: 2000,
        },
      },
    });
  } else {
    dataLayer.push({
      event: `productClick`,
      ecommerce: {
        click: {
          products: [admind_product],
          eventCallback: () => {
            document.location = product.product_url;
          },
          eventTimeout: 2000,
        },
      },
    });
  }
};
